module.exports = __webpack_public_path__ + "static/media/share.028198b8.svg";